import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-message-banner',
  standalone: true,
  host: { class: 'block min-w-0' },
  templateUrl: './message-banner.component.html',
})
export class MessageBannerComponent {
  readonly type = input<'success' | 'error' | 'warning' | 'info'>('info');
  readonly dismissed = output<void>();
}
